import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { EspaciosCurricularesRow } from "./EspaciosCurricularesRow";
import { EspaciosCurricularesDetailModal } from "../EspaciosCurricularesDetailModal/EspaciosCurricularesDetailModal";

interface Props {
  elementos: EspacioCurricularI[];
  renderActions?: (
    elemento: EspacioCurricularI,
    onClickShowDetail: (elemento: EspacioCurricularI) => void,
  ) => ReactNode;
}

export const EspaciosCurricularesTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  const [selectedElement, setSelectedElement] =
    useState<EspacioCurricularI | null>(null);
  const [showModal, setShowModal] = useState(false);

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };

  const onShowDetailModal = (elemento: EspacioCurricularI) => {
    setSelectedElement(elemento);
    setShowModal(true);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripcion</th>
            <th>Área</th>
            <th>Nivel</th>
            <th>Ciclo</th>
            <th>Cursado</th>
            <th>Tipo espacio</th>
            <th>Sub tipo</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <EspaciosCurricularesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 12 : 12}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay diseños curriculares para visualizar.</b> Para poder
                  visualizar diseños curriculares debes <br /> seleccionar el
                  botón agregar «Nuevo diseño curricular».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <EspaciosCurricularesDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      />
    </>
  );
};
